import React, { useEffect, useRef, useState } from 'react'
import "./Header.css"
import { useLocation, useNavigate } from 'react-router-dom'
import { openBooking, INSTAGRAM_URL } from '../../utils/links'

function loadScript(src) {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) {
      resolve(); // already loaded
      return;
    }
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.onload = resolve;
    script.onerror = reject;
    document.body.appendChild(script);
  });
}

function Header() {
  const navigate = useNavigate()
  const location = useLocation()

  const isActive = (path) => location.pathname === path

  const [scrolled, setScrolled] = useState(false)

  const [isOpen, setIsOpen] = useState(false);
  const initializedRef = useRef(false);

  const openModal = () => setIsOpen(true);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // you can use 50px OR percentage
      const scrollY = window.scrollY
      const triggerPoint = window.innerHeight * 0.1 // 50% of screen

      if (scrollY > triggerPoint) {
        setScrolled(true)
      } else {
        setScrolled(false)
      }
    }

    window.addEventListener("scroll", handleScroll)

    return () => window.removeEventListener("scroll", handleScroll)
  }, [])




  const closeModal = () => {
    setIsOpen(false);
    initializedRef.current = false;
  };

  useEffect(() => {
    if (!isOpen || initializedRef.current) return;

    const initWidget = async () => {
      try {
        await loadScript(
          "https://ajax.googleapis.com/ajax/libs/jquery/3.2.0/jquery.min.js"
        );

        await loadScript(
          "https://code.jquery.com/ui/1.12.1/jquery-ui.js"
        );

        // Load jQuery UI CSS
        if (!document.querySelector('link[href*="jquery-ui"]')) {
          const link = document.createElement("link");
          link.rel = "stylesheet";
          link.href =
            "https://code.jquery.com/ui/1.12.1/themes/base/jquery-ui.css";
          document.head.appendChild(link);
        }

        const $ = window.jQuery;

        const date = new Date();
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);

        function ajaxRequest(senddata) {
          $.ajax({
            url: "https://asiatech.in/booking_engine/admin/widget",
            type: "POST",
            data: senddata,
            dataType: "html",
            headers: {
              Accept: "application/json",
            },
            success: function (data) {
              $("#loadingimg").hide();
              $("#pricecal").show().html(data);
            },
          });
        }

        $("#datepick").datepicker({
          dateFormat: "dd-mm-yy",
          minDate: 0,
          onSelect: function () {
            $("#pricecal").hide();
            $("#loadingimg").show();

            const b = $("#datepick").datepicker("getDate");

            b.setDate(b.getDate() + 1);

            $("#datepick1").datepicker("setDate", b);
            $("#datepick1").datepicker("option", "minDate", b);

            ajaxRequest($("#widgetform").serializeArray());
          },
        });

        $("#datepick1").datepicker({
          dateFormat: "dd-mm-yy",
          minDate: 1,
          onClose: function () {
            $("#pricecal").hide();
            $("#loadingimg").show();

            const a = $("#datepick").datepicker("getDate");
            const b = $("#datepick1").datepicker("getDate");

            if (a >= b) {
              const c = $("#datepick1").datepicker("option", "minDate");
              $("#datepick1").datepicker("setDate", c);
            }

            ajaxRequest($("#widgetform").serializeArray());
          },
        });

        $("#datepick").datepicker("setDate", date);
        $("#datepick1").datepicker("setDate", tomorrow);

        $("#loadingimg").show();

        ajaxRequest($("#widgetform").serializeArray());

        initializedRef.current = true;
      } catch (err) {
        console.error("Booking widget failed:", err);
      }
    };

    initWidget();
  }, [isOpen]);

  return (
    <>
      <header className={` ${scrolled ? "fixed_top" : ""}`}>
        {/* --- TOP DARK BAR --- */}
        <div className="top-bar">
          <div className="container">
            <div className="row align-items-center">
              {/* Phone Numbers */}
              <div className="col-8 d-flex gap-4">
                <div className="d-flex align-items-center gap-2">
                  <img loading="lazy" decoding="async" src={require("../../assets/images/phone.png")} alt='phone' />
                  <span>+91-8279640517</span>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <img loading="lazy" decoding="async" src={require("../../assets/images/phone.png")} alt='phone' />
                  <span>+91-7983379732</span>
                </div>
              </div>

              {/* Social Icons */}
              <div className="col-4 d-flex justify-content-end gap-3">
                <a href={INSTAGRAM_URL} target='_blank' rel='noopener noreferrer'>
                  <img loading="lazy" decoding="async" src={require("../../assets/images/instragram.png")} alt='image' />
                </a>
                <a href='https://www.facebook.com/camphornbillcorbett?mibextid=ZbWKwL' target='_blank'>
                  <img loading="lazy" decoding="async" src={require("../../assets/images/facebook.png")} alt='image' />
                </a>
                <a href='https://www.google.com/travel/search?q=google%20reviews%20camp%20hornbill&g2lb=4814050%2C4874190%2C4893075%2C4899571%2C4899572%2C4965990%2C4969803%2C72277293%2C72302247%2C72317059%2C72406588%2C72414906%2C72421566%2C72471280%2C72472051%2C72473841%2C72481459%2C72485658%2C72536387%2C72602734%2C72614662%2C72616120%2C72619927%2C72620306%2C72647020%2C72648289%2C72658035%2C72671093%2C72686036%2C72726180%2C72749221%2C72757848%2C72770823&hl=en-IN&gl=in&ssta=1&ts=CAEaRwopEicyJTB4MzkwYTEyYTJkMjRmOGI4MzoweGE3Y2JhNGRlODhhMzI0ZDcSGhIUCgcI6A8QChgHEgcI6A8QChgIGAEyAhAA&qs=CAEyFENnc0kxOG1NeGVpYjZlV25BUkFCOAJCCQnXJKOI3qTLp0IJCdcko4jepMun&ap=ugEHcmV2aWV3cw&ictx=111&ved=0CAAQ5JsGahcKEwiYwKC75_eIAxUAAAAAHQAAAAAQEg' target='_blank'>
                  <img loading="lazy" decoding="async" src={require("../../assets/images/google.png")} alt='image' />
                </a>
                <a href='https://www.youtube.com/@camphornbillcorbett' target='_blank'>
                  <img loading="lazy" decoding="async" src={require("../../assets/images/youtube.png")} alt='image' />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* --- MAIN NAVIGATION --- */}
        <nav className="navbar navbar-expand-xl main-navbar">
          <div className="container">
            <a className="navbar-brand" href="/">
              <img loading="lazy" decoding="async" src={require("../../assets/images/logo.png")} alt="Camp Hornbill" />
            </a>

            <button
              className="navbar-toggler"
              type="button"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-expanded={menuOpen}
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className={`collapse navbar-collapse ${menuOpen ? "show" : ""}`}
              id="navbarNav">
              <ul className="navbar-nav ms-auto align-items-center">
                <li className="nav-item">
                  <a className={`nav-link ${isActive('/') ? 'active' : ''}`} onClick={() => { navigate("/"); setMenuOpen(false); }}>Home</a>
                </li>
                <li className="nav-item">
                  <a className={`nav-link ${isActive('/experience') ? 'active' : ''}`} onClick={() => { navigate("/experience"); setMenuOpen(false); }}>Experience</a>
                </li>
                <li className="nav-item">
                  <a className={`nav-link ${isActive('/stay') ? 'active' : ''}`} onClick={() => { navigate("/stay"); setMenuOpen(false); }}>Stay</a>
                </li>
                <li className="nav-item">
                  <a className={`nav-link ${isActive('/learning') ? 'active' : ''}`} onClick={() => { navigate("/learning"); setMenuOpen(false); }}>Learning & Groups</a>
                </li>
                <li className="nav-item">
                  <a className={`nav-link ${isActive('/family-retreats') ? 'active' : ''}`} onClick={() => { navigate("/family-retreats"); setMenuOpen(false); }}>Family Retreats</a>
                </li>
                <li className="nav-item">
                  <a className={`nav-link ${isActive('/community-Conservation') ? 'active' : ''}`} onClick={() => { navigate("/community-Conservation"); setMenuOpen(false); }}>Community & Conservation</a>
                </li>
                <li className="nav-item">
                  <a className={`nav-link ${isActive('/our-story') ? 'active' : ''}`} onClick={() => { navigate("/our-story"); setMenuOpen(false); }}>Our Story</a>
                </li>
                <li className="nav-item">
                  <a className={`nav-link ${isActive('/gallery') ? 'active' : ''}`} onClick={() => { navigate("/gallery"); setMenuOpen(false); }}>Gallery</a>
                </li>
                <li className="nav-item">
                  <a className={`nav-link ${isActive('/contact-us') ? 'active' : ''}`} onClick={() => { navigate("/contact-us"); setMenuOpen(false); }}>Contact Us</a>
                </li>
                {/* <li className="nav-item">
                <a className={`nav-link ${isActive('/hornbill-collective') ? 'active' : ''}`} onClick={() => navigate("/hornbill-collective")}>Hornbill Collective</a>
              </li> */}
                <li className="nav-item ms-lg-3">
                  <button className="primary_btn" onClick={() => { openBooking(); setMenuOpen(false); }}>Book Now</button>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </header>



      {isOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>✕</button>

            {/* New styling from Asiatech, scoped to this modal */}
            <style>{`
              .modal-content td,
              .modal-content th {
                padding: 4px 1px;
                border-top: 1px solid #ddd;
              }
              .modal-content tbody tr:nth-child(odd) {
                background-color: #f9f9f9;
              }
              .modal-content input {
                background: url(https://asiatech.in/booking_engine/superadmin/images/calendar-icon.png) no-repeat 5px;
                padding-left: 25px;
                border: 1px solid #ccc;
              }
            `}</style>

            <form className="form-inline" role="form" id="widgetform">
              <table
                cellPadding="0"
                cellSpacing="0"
                style={{
                  border: "1px solid #dddddd",
                  textAlign: "center",
                }}
              >
                <thead>
                  <tr
                    style={{
                      background: "#9F1F63",
                      color: "white",
                      fontSize: "18px",
                    }}
                  >
                    <td colSpan="2">CAMP HORNBILL CORBETT</td>
                  </tr>

                  <tr>
                    <td>
                      <input
                        type="hidden"
                        name="token"
                        value="3437303065633635663562306239663534396331306163643338303730346534"
                      />

                      <input
                        type="text"
                        className="form-control"
                        name="datepick"
                        id="datepick"
                        placeholder="Check In"
                        readOnly
                        style={{
                          width: "125px",
                        }}
                      />
                    </td>

                    <td>
                      <input
                        type="text"
                        className="form-control"
                        name="datepick1"
                        id="datepick1"
                        placeholder="Check Out"
                        readOnly
                        style={{
                          width: "125px",
                        }}
                      />
                    </td>
                  </tr>
                </thead>

                <tbody id="pricecal"></tbody>
              </table>

              <img
                id="loadingimg"
                src="https://asiatech.in/booking_engine/superadmin/images/loader_small.gif"
                alt="Loading..."
                style={{
                  display: "block",
                  float: "left",
                }}
              />
            </form>
          </div>
        </div>
      )}
    </>
  )
}

export default Header